var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTokenSOhm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9453 93.7637C74.0246 93.7637 93.5448 74.2435 93.5448 50.1641C93.5448 45.1066 92.6837 40.2501 91.1 35.7334V21.5178C96.7113 29.5997 100 39.4158 100 50C100 77.6142 77.6142 100 50 100C22.3858 100 0 77.6142 0 50C0 39.353 3.3278 29.4833 9 21.3743V35.1494C7.28293 39.8305 6.3457 44.8879 6.3457 50.1641C6.3457 74.2435 25.8659 93.7637 49.9453 93.7637Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1001 50C11.1001 28.5161 28.5162 11.1 50.0001 11.1C71.484 11.1 88.9001 28.5161 88.9001 50C88.9001 71.4839 71.484 88.9 50.0001 88.9C28.5162 88.9 11.1001 71.4839 11.1001 50Z",
    fill: "#708B96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7345 65.4747C53.7345 65.4747 53.7345 65.4747 53.7345 65.4747V67.1938H67.1161V62.3702H60.5078C64.4837 59.3579 67.0381 54.6753 67.0381 49.4165C67.0381 40.3288 59.4099 32.9618 49.9999 32.9618C40.59 32.9618 32.9617 40.3288 32.9617 49.4165C32.9617 54.6753 35.5161 59.3579 39.492 62.3702H32.884V67.1938H46.2656V65.4747L46.2657 60.7106C41.3899 59.1759 37.8633 54.717 37.8633 49.4554C37.8633 42.9243 43.2971 37.6298 50.0001 37.6298C56.703 37.6298 62.1369 42.9243 62.1369 49.4554C62.1369 54.717 58.6102 59.176 53.7345 60.7107V65.4747Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -83.5339,
    y1: 50,
    x2: 189.059,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#708B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBE7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenSOhm);
export default __webpack_public_path__ + "static/media/token_sOHM.aed3bba5.svg";
export { ForwardRef as ReactComponent };